import React from 'react';
import PropTypes from 'prop-types';
import { ICON_NAMES } from './constants';

export const Icon = ({ name, size, color }) => {
  const IconToRender = ICON_NAMES[name];
  return <IconToRender size={size} color={color} />;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  color: PropTypes.string
};

export default Icon;
